import { mergeOverrides as mergeOverrides$1, getOverrides as getOverrides$1 } from 'baseui';

const mergeOverrides = mergeOverrides$1;
const getOverrides = getOverrides$1;

export { getOverrides, mergeOverrides };
